import { Global, MiddlewareConsumer, Module, NestModule, Provider } from '@nestjs/common';
import { APP_FILTER, APP_INTERCEPTOR } from '@nestjs/core';
import { TerminusModule } from '@nestjs/terminus';

import { HealthController, PusherController } from './controllers';
import { AllExceptionsFilter } from './filters';
import { LoggingInterceptor, ResponseInterceptor } from './interceptors';
import { WinstonLogger } from './loggers';
import { RequestIdMiddleware } from './middlewares';
import { PusherService } from './services';

@Global()
@Module({
  controllers: [HealthController, PusherController],
  exports: [PusherService, WinstonLogger],
  imports: [TerminusModule],
  providers: [
    { provide: APP_FILTER, useClass: AllExceptionsFilter },
    process.env['NODE_ENV'] !== 'production' && { provide: APP_INTERCEPTOR, useClass: LoggingInterceptor },
    { provide: APP_INTERCEPTOR, useClass: ResponseInterceptor },
    PusherService,
    WinstonLogger,
  ].filter(Boolean) as Provider[],
})
export class CoreModule implements NestModule {
  public configure(consumer: MiddlewareConsumer): any {
    consumer.apply(RequestIdMiddleware).forRoutes('*');
  }
}
